import { useBlockElementCache } from "./useBlockElementCache.js";
import { useEntityList, useDesugaredRelativeSingleField, sortEntities } from "@contember/binding";
import { useBlockElementPathRefs } from "./useBlockElementPathRefs.js";
import { useBlockEditorOnChange } from "./useBlockEditorOnChange.js";
import { useRef, useMemo, useEffect } from "react";
import { useBlockEditorSlateNodes } from "../useBlockEditorSlateNodes.js";
import { useRefreshBlocks } from "./useRefreshBlocks.js";
const useBlockEditorState = ({ editor, blockList, sortableBy, contentField, monolithicReferencesMode, referencesField }) => {
  const entityList = useEntityList(blockList);
  const desugaredSortableByField = useDesugaredRelativeSingleField(sortableBy);
  const trashFakeBlockId = useRef();
  const sortedBlocks = useMemo(() => {
    return sortEntities(
      Array.from(entityList).filter((it) => it.id !== trashFakeBlockId.current),
      desugaredSortableByField
    );
  }, [desugaredSortableByField, entityList]);
  const sortedBlocksRef = useRef(sortedBlocks);
  useEffect(() => {
    sortedBlocksRef.current = sortedBlocks;
  }, [sortedBlocks]);
  const blockElementCache = useBlockElementCache({ editor, blockList, sortableBy, contentField });
  const blockElementPathRefs = useBlockElementPathRefs({ editor, blockList });
  const refreshBlocks = useRefreshBlocks({ editor, sortableBy, contentField, blockList, blockElementCache, blockElementPathRefs, referencesField, monolithicReferencesMode, sortedBlocksRef, trashFakeBlockId });
  const onChange = useBlockEditorOnChange({ editor, blockList, contentField, blockElementCache, sortedBlocksRef, refreshBlocks });
  const nodes = useBlockEditorSlateNodes({ editor, blockElementCache, blockElementPathRefs, blockContentField: contentField, topLevelBlocks: sortedBlocks });
  return { onChange, nodes, sortedBlocksRef, refreshBlocks };
};
export {
  useBlockEditorState
};
//# sourceMappingURL=useBlockEditorState.js.map
